import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EXPORT_URL } from '@marmon/frontend/common';
import { ExportPayload } from '@marmon/shared/types/export';
import { catchError, firstValueFrom, of, tap } from 'rxjs';
import { ExportStateService } from './export-state.service';

@Injectable({ providedIn: 'root' })
export class ExportApiService {
	protected readonly exportUrl = inject(EXPORT_URL);
	protected readonly http = inject(HttpClient);

	private readonly exportStateService = inject(ExportStateService);

	generate<T extends object = object>(payload: ExportPayload<T>) {
		this.exportStateService.startGeneratingData(payload);
		return firstValueFrom(
			this.http
				.post(`${this.exportUrl}/v1/export`, payload, {
					responseType: 'text',
				})
				.pipe(
					catchError((error) => {
						console.error('Error completing csv', error);
						this.exportStateService.updateGeneratingData({
							error: true,
						});
						return of(undefined);
					}),
					tap((csv) => {
						this.exportStateService.endGeneratingData(csv);
					}),
				),
		);
	}
}
